export default "__VITE_ASSET__CptDzXkv__"